import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTooltip } from './TooltipManager.tsx'

// This Component listens to route changes and hides any active tooltips, this avoids tooltips lingering on screen when navigating
export function TooltipLocationBridge() {
  const location = useLocation()
  const { hideTooltip } = useTooltip()

  useEffect(() => {
    hideTooltip()
  }, [location])

  return null
}
